import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import SkeletonFeaturedUpdate from "../skeleton/SkeletonFeaturedUpdate";

interface UpdateProps {
  event_id: number;
  event_title: string;
  event_img: string;
  event_category: string;
  thumbnail_image: string;
  event_date: string;
  slug: string;
}

const FeaturedUpdate: React.FC<{ featured: UpdateProps | null }> = ({ featured }) => {
  const [imgLoading, setImgLoading] = useState(true);

  // 👇 SAFE defaults (so hooks always run)
  const imageUrl = featured?.thumbnail_image || "";
  const hasImage = Boolean(imageUrl);

  // 👇 Hook is ALWAYS called
  useEffect(() => {
    setImgLoading(true);
  }, [imageUrl]);

  // 👇 Early return AFTER hooks
  if (!featured) return  <SkeletonFeaturedUpdate />;

  return (
 
    <Link
      className="text-decoration-none text-dark"
      to={`/updates/${featured.slug}`}
    >
      <div className="update_top_wrap">
        
        <div className="update_content">
          <span className="update_type">{featured.event_category}</span>

          <h5 className="update_top_title">
            {featured.event_title}
          </h5>

          <div className="update_footer">
            <p className="posting_date">
              {new Date(featured.event_date).toDateString()}
            </p>
          </div>
        </div>
        
 {imgLoading && <SkeletonFeaturedUpdate />}
        <div className="top_static_img" >
         

          {/* Image */}
          {/* {hasImage && ( */}
          
            <img
              src={imageUrl}
              alt={featured.event_title}
              className="img-fluid"
              onLoad={() => setImgLoading(false)}
              onError={() => setImgLoading(false)}
              style={{ display: imgLoading ? "none" : "block" }}
            />
          
          {/* )} */}
        </div>
      </div>
    </Link>

    
  );
};

export default FeaturedUpdate;
